import {showToast} from "./toast";
import {route} from "ziggy-js";
import {trans} from "../i18n/i18n";
import {Toast} from "../consts/toast";

document.addEventListener("DOMContentLoaded", () => {
    const brandsSection = document.getElementById("vehicle-brands-supported");
    const loadMoreButton = document.getElementById("load-more-brands");

    if (!brandsSection || !loadMoreButton) return;

    // Skip if the brands are already shown (Google bot case)
    if (!document.querySelector(".brands-list-all").classList.contains("d-none")) {
        return;
    }

    loadMoreButton.addEventListener("click", () => handleLoadMore(loadMoreButton));

    // Check if the URL contains #vehicle-brands-supported load more brands straight away
    if (window.location.hash === '#vehicle-brands-supported') {
        setTimeout(() => {
            loadMoreButton.click();
        }, 150);
    }
});

/**
 * Handles the click event for showing all vehicle brands.
 * @param {HTMLElement} button - The "Load more brands" button element.
 */
async function handleLoadMore(button) {
    if (button.dataset.loading === "true") return;

    setLoadingState(button, true);

    try {
        const mostSearchedList = document.querySelector(".brands-list-most-searched");
        const allBrandsList = document.querySelector(".brands-list-all");
        const brandsListContainer = document.querySelector(".vehicle-brands-supported-brands-list");

        if (!mostSearchedList || !allBrandsList || !brandsListContainer) {
            console.warn("Required elements not found.");
            return;
        }

        // Apply fade-out to the container
        brandsListContainer.style.opacity = "0";
        
        // Wait for fade out to complete
        setTimeout(() => {
            // Hide most searched brands list
            mostSearchedList.classList.add("d-none");
            
            // Show all brands list
            allBrandsList.classList.remove("d-none");
            allBrandsList.classList.add("d-flex", "wrap");

            // Animate items in the all brands list
            const items = allBrandsList.querySelectorAll("li");
            items.forEach((item, index) => {
                item.style.opacity = "0";
                const delay = Math.min(index * 10, 300); // Cap maximum delay at 300ms
                setTimeout(() => {
                    item.style.opacity = "1";
                }, delay);
            });
            
            // Fade the container back in
            setTimeout(() => {
                brandsListContainer.style.opacity = "1";
            }, 50);
            
            // Remove the button after showing all brands
            button.remove();
        }, 300); // Wait 300ms for the fade-out effect
        
    } catch (error) {
        showToast(trans("Failed to display all brands. Please try again later."), Toast.ERROR);
    } finally {
        setLoadingState(button, false);
    }
}

/**
 * Replaces the brand list with a new set of brands, displaying them one by one from top to bottom.
 * First 2000 items will be animated with 10ms delay, remaining items with 1ms delay.
 *
 * @param {Array} brands - Array of manufacturer objects.
 */
function replaceBrandsInList(brands) {
    const brandsList = document.querySelector(".vehicle-brands-supported-brands-list ul");

    // Create a document fragment to efficiently insert new list items
    const fragment = document.createDocumentFragment();

    // Create all elements but set them to be initially invisible
    brands.forEach((manufacturer) => {
        const li = document.createElement("li");
        const manufacturerUrl = route("manufacturer.show", { manufacturer: manufacturer.url_friendly });
        li.innerHTML = `<a href="${manufacturerUrl}">${manufacturer.make}</a>`;
        li.style.opacity = "0";
        fragment.appendChild(li);
    });

    // First clear the list
    brandsList.innerHTML = "";
    brandsList.appendChild(fragment);

    // Then animate each item with appropriate delay based on position
    const items = brandsList.querySelectorAll("li");
    items.forEach((item, index) => {
        const delay = index < 200 ? 10 * index : 2000 + (index - 200);
        setTimeout(() => {
            item.style.opacity = "1";
        }, delay);
    });
}

/**
 * Updates the button state to indicate loading progress.
 * @param {HTMLElement} button - The button element.
 * @param {boolean} isLoading - Whether the button should be in a loading state.
 */
function setLoadingState(button, isLoading) {
    button.textContent = isLoading ? trans("status.Loading...") : trans("Load more brands");
    button.disabled = isLoading;

    button.dataset.loading = isLoading.toString();
}
